<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="w-100">
        <label>{{ label }}</label>
        <v-select
          placeholder="Busque por código o nombre"
          :options="communes"
          :name="name"
          :value="optionSelected"
          :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
          :disabled="isDisabled"
          @input="onInput"
          :clearable="isClearable"
        />
      </div>
      <vs-icon
        class="ml-2 mt-5 pt-1 cursor-pointer"
        icon="remove_circle_outline"
        size="small"
        v-tooltip="'Eliminar comuna'"
        color="danger"
        @click="clearCommune"
      />
    </div>
    <div v-if="danger">
      <small>
        <span class="text-danger"> {{ dangerText }} </span>
      </small>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ListCommunes',
  computed: {
    ...mapGetters('Dnts', ['communes']),
    optionSelected() {
      return this.communes.find((option) => option.codigo === this.value);
    },
  },
  methods: {
    ...mapActions('Dnts', ['getCommunes']),
    onInput(event) {
      this.$emit('input', event?.codigo);
    },
    getOption() {
      return this.communes.find((option) => option.codigo === this.value);
    }
  },
  created() {
    this.getCommunes({ tipo: 'comuna' });
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Comunas' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    isDisabled: { type: Boolean, default: false },
    clearCommune: { type: Function }
  }
};

</script>
